import { ArrowRight, Phone, MapPin, Star } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_241680e8-f543-49d6-8cb5-996f4ac63eff/artifacts/4acluarf_IMG_0892.jpeg";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 lg:pt-32 pb-20 lg:pb-28 stripe-bg-v"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-end">
        {/* Left: copy */}
        <div className="lg:col-span-7 reveal">
          <div className="inline-flex items-center gap-3 border border-[#0B1C14]/20 bg-[#F4F3EF] px-3 py-1.5 mb-7">
            <span className="w-1.5 h-1.5 bg-[#E64C23] rounded-full" />
            <span className="font-mono-accent text-[11px] tracking-[0.22em] uppercase text-[#0B1C14]">
              Traverse City, MI · Locally Owned
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display uppercase text-[44px] sm:text-6xl lg:text-[88px] xl:text-[104px] leading-[0.88] text-[#0B1C14]"
          >
            Sharp lines.
            <br />
            Honest <span className="text-[#E64C23]">work.</span>
            <br />
            Lawns that <span className="italic">stripe</span>.
          </h1>

          <p
            data-testid="hero-subcopy"
            className="mt-7 max-w-xl text-base sm:text-lg leading-relaxed text-[#4A5D53] font-medium"
          >
            Crosscut Lawn Care is a Traverse City crew obsessed with the small
            stuff — clean edges, even passes, and that picture‑perfect ballpark
            stripe. You grow it, we&apos;ll mow it.
          </p>

          <div className="mt-9 flex flex-wrap gap-4">
            <a
              data-testid="hero-cta-quote"
              href="#contact"
              className="btn-primary"
            >
              Request a Free Quote
              <ArrowRight size={16} strokeWidth={2.5} />
            </a>
            <a
              data-testid="hero-cta-call"
              href="tel:+12314635080"
              className="btn-secondary"
            >
              <Phone size={16} strokeWidth={2.5} />
              (231) 463-5080
            </a>
          </div>

          {/* Trust strip */}
          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-[#0B1C14]/10 pt-6">
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={15}
                    className="fill-[#E64C23] text-[#E64C23]"
                  />
                ))}
              </div>
              <span className="font-mono-accent text-xs tracking-[0.18em] uppercase text-[#0B1C14]">
                Neighbor‑recommended
              </span>
            </div>
            <div className="flex items-center gap-2 font-mono-accent text-xs tracking-[0.18em] uppercase text-[#4A5D53]">
              <MapPin size={14} strokeWidth={2.5} />
              Grand Traverse County
            </div>
            <div className="font-mono-accent text-xs tracking-[0.18em] uppercase text-[#4A5D53]">
              Fully Insured
            </div>
          </div>
        </div>

        {/* Right: image card */}
        <div className="lg:col-span-5 relative reveal" style={{ animationDelay: "0.15s" }}>
          {/* Backing rectangle */}
          <div className="absolute -inset-3 lg:-inset-5 bg-[#0B1C14] -z-0" aria-hidden />
          <div className="absolute -bottom-4 -right-4 w-24 h-24 lg:w-32 lg:h-32 bg-[#E64C23] -z-0" aria-hidden />

          <div
            data-testid="hero-photo"
            className="relative z-10 border-2 border-[#0B1C14] overflow-hidden aspect-[4/5] bg-[#0B1C14]"
          >
            <img
              src={HERO_IMG}
              alt="Front lawn with crisp mowing stripes, Crosscut Lawn Care"
              className="w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 pointer-events-none mix-blend-multiply opacity-[0.12]"
              style={{
                backgroundImage:
                  "repeating-linear-gradient(180deg, transparent 0 22px, rgba(0,0,0,0.4) 22px 23px)",
              }}
            />
            {/* Caption tag */}
            <div className="absolute left-4 bottom-4 bg-[#F4F3EF] px-3 py-2 border-2 border-[#0B1C14]">
              <div className="font-mono-accent text-[10px] tracking-[0.22em] uppercase text-[#4A5D53]">
                Job · South Creek
              </div>
              <div className="font-display text-sm uppercase tracking-tight text-[#0B1C14]">
                Striped & Edged
              </div>
            </div>
          </div>

          {/* Floating stat */}
          <div className="hidden lg:flex absolute -left-10 top-8 z-20 flex-col bg-[#E64C23] text-white px-5 py-4 border-2 border-[#0B1C14] shadow-craftsman-sm rotate-[-4deg]">
            <span className="font-mono-accent text-[10px] tracking-[0.25em] uppercase opacity-90">
              Avg. Stripe Width
            </span>
            <span className="font-display text-3xl leading-none uppercase">
              42&quot;
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
